import { NgModule } from '@angular/core';
import { DragSelectionDirective } from './drag-selection.directive';

@NgModule({
  declarations: [DragSelectionDirective],
  exports: [DragSelectionDirective],
})
export class DragSelectionModule {}
